<template>
  <div>
    <section v-if="body" class="text_center">
      <h2 class="header_underline">お問い合わせ送信内容確認</h2>
      <div class="confirm_box">
        <div>
          <p class="text_left body">{{ body }}</p>
          <div v-if="image" class="image mb-4">
            <img :src="previewUrl"/>
          </div>
        </div>
        <p class="text_left highlight_yellow actor_message_confirm_text actor_message_text">上記の内容でよろしければ、[送信]ボタンを押して下さい。</p>
        <v-btn class="send_btn" rounded @click="submit">送信</v-btn>
        <v-btn text class="emphasis--text" @click="goEdit(id)">修正する</v-btn>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SupportMessageConfirm',
  data () {
    return {
      id: null,
      support_id: null,
      name: '',
      body: '',
      image: null,
      previewUrl: null
    }
  },
  methods: {
    submit () {
      const params = {
        support_id: this.support_id,
        body: this.body,
        image: this.image
      }
      this.$store.dispatch('replySupport', params)
        .then(() => {
          this.$router.push({
            name: 'SupportMessageComplete'
          }).catch(err => {
            if (!err.message.includes('Redirected')) {
              throw err
            }
          })
        })
        .catch(err => {
          console.error('送信失敗', err)
        })
    },
    goEdit (id) {
      this.$router.push({
        name: 'SupportBoxDetail',
        params: {
          id,
          from: {
            support_id: this.support_id,
            body: this.body,
            image: this.image,
            previewUrl: this.previewUrl
          }
        }
      }).catch(err => {
        if (!err.message.includes('Redirected')) {
          console.error(err)
        }
      })
    }
  },
  created () {
    const pathParts = this.$route.path.split('/')
    this.id = pathParts[2] || null

    const from = (this.$route.params && this.$route.params.from) || {}
    this.support_id = from.support_id || this.id
    this.name = from.support_name || null
    this.body = from.body || ''
    this.image = from.image || null
    this.previewUrl = from.previewUrl || null

    if (!this.body || this.body.trim() === '') {
      this.goEdit(this.id)
    }
  }
}
</script>
